import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React, {useRef} from 'react';
import {CSSTransition} from 'react-transition-group';
import {twMerge} from 'tailwind-merge';

import {
  INITIAL_DRAWER_WIDTH_CLASS_NAME,
  INLINE_WORKSPACE_DRAWER_DURATION,
  INLINE_WORKSPACE_DRAWER_DURATION_CLASS_NAME,
} from './constants';

export const InlineWorkspaceDrawer = ({
  isDrawerOpen,
  children,
}: {
  isDrawerOpen: boolean;
  children: React.ReactNode;
}) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <TailwindContents>
      <CSSTransition
        nodeRef={ref}
        in={isDrawerOpen}
        timeout={INLINE_WORKSPACE_DRAWER_DURATION}
        classNames={{
          enter: 'w-0 opacity-0',
          enterActive: twMerge(
            '!opacity-100',
            INITIAL_DRAWER_WIDTH_CLASS_NAME,
            INLINE_WORKSPACE_DRAWER_DURATION_CLASS_NAME
          ),
          exit: twMerge('opacity-100', INITIAL_DRAWER_WIDTH_CLASS_NAME),
          exitActive: twMerge(
            '!w-0 !opacity-0',
            INLINE_WORKSPACE_DRAWER_DURATION_CLASS_NAME
          ),
        }}
        unmountOnExit>
        <div ref={ref} className="h-full">
          {children}
        </div>
      </CSSTransition>
    </TailwindContents>
  );
};
